import { LanguageMessage } from './language-message';
import { LanguageMessageForZh } from './language-message-zh';
import { LanguageMessageForEn } from './language-message-en';
import { LanguageMessageForZhft } from './language-message-zhft';
class LanguageMessageFactory {

  private static languageMessageMap: Map<string, LanguageMessage> = new Map<string, LanguageMessage>();

  /**
   * Create an instance by language
   */
  public static create(language: string): LanguageMessage {
    if (this.languageMessageMap.has(language) === true) {
      return this.languageMessageMap.get(language);
    }

    let languageMessage: LanguageMessage;
    switch (language) {
      case 'zh-CHS':
        languageMessage = new LanguageMessageForZh();
        break;
      case 'en':
        languageMessage = new LanguageMessageForEn();
        break;
      case 'zh-CHT':
        languageMessage = new LanguageMessageForZhft();
        break;
      default:
        languageMessage = new LanguageMessageForZh();
        break;
    }
    this.languageMessageMap.set(language, languageMessage);

    return languageMessage;
  }
}

export { LanguageMessageFactory };
